export default class Navigator {
    
    public static NavigateTo(path: string) {
        window.location.pathname = path;
    }

    public static GetQueryStringParams() : {Key: string, Value : string}[]
    {
         const queryString = window.location.search; 
         const urlParams = new URLSearchParams(queryString);
        
         const result : ReturnType<typeof Navigator.GetQueryStringParams>  = Array.from(urlParams.entries()).map(([key, value]) => ({
            Key: key, 
            Value : value
         }));


         return result;
           
    }

    public static NavigateToWithQueryParams(path: string, queryParams: Record<string, string>) {
        const queryString = new URLSearchParams(queryParams).toString();
        window.location.pathname = `${path}?${queryString}`;
    }

    public static NavigateToHome() {
        window.location.pathname = '/';
    }

    public static Path()
    {
        return window.location.pathname;
    }

    public static GetBrowserName() {
        const userAgent = navigator.userAgent;
        let browserName = "Unknown";

        if (userAgent.includes("Edg")) {
            browserName = "Microsoft Edge";
        } else if (userAgent.includes("Chrome") && !userAgent.includes("Edg")) {
            browserName = "Chrome";
        } else if (userAgent.includes("Firefox")) {
            browserName = "Firefox";
        } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {           
            browserName = "Safari";
        } else if (userAgent.includes("Opera") || userAgent.includes("OPR")) {
            browserName = "Opera";
        } else if (userAgent.includes("MSIE") || userAgent.includes("Trident")) {
            browserName = "Internet Explorer";
        }

        return browserName;
    }

}